// @vendors
import { create } from 'zustand';

// @services
import statisticService from '../services/statistic.service';

// @types
import { Statistic } from '../types/statistic.types';

interface StatisticState {
  statistics: Statistic | null;
  fetchStatistics: (professionalId: string) => Promise<void>;
}

const useStatisticStore = create<StatisticState>((set) => ({
  statistics: null,

  fetchStatistics: async (professionalId: string) => {
    const statistics = await statisticService.getStatistics(professionalId);
    set({ statistics });
  },
}));

export default useStatisticStore;